import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { AppService } from '@core/services/app.service';
import { ECurrencyCode } from '@shared/models';

@Component({
  selector: 'currency',
  templateUrl: './currency.component.html',
  styleUrls: ['./currency.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CurrencyComponent implements OnInit {
  @Input() code: ECurrencyCode;
  
  constructor(
    public app: AppService
  ) { }

  ngOnInit(): void {
  }

}
